import { render, staticRenderFns } from "./IdealerassignvehicleAccept.vue?vue&type=template&id=a24b41ce"
import script from "./IdealerassignvehicleAccept.vue?vue&type=script&lang=js"
export * from "./IdealerassignvehicleAccept.vue?vue&type=script&lang=js"
import style0 from "./IdealerassignvehicleAccept.vue?vue&type=style&index=0&id=a24b41ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports